import { attributes, define, type, value } from "@type-r/models";
import { renameProperty } from './common';

@define
export class ShippingNotice extends attributes({
    po_number: String,
    packing_slip_number: String,
    planned_delivery_date_utc: Date,
    created_on_utc: type( Date ).dontSave,
    package_tracking_number: "",

    items : [{
        quote_id: "",
        package_tracking_number: "",
        shipping_notice_id: "",
        assigned_identification: Number,
        units_shipped: Number,
        serial_numbers: value([]), // TODO: convert on the server
        quote_line_id: "",
        part_number: "",
        quantity: Number,
        unshipped_items: Number
    }]
}) {
    parse(json: any): any {
        renameProperty(json, 'poNumber', 'po_number');
        renameProperty(json, 'packingSlipNumber', 'packing_slip_number');
        renameProperty(json, 'plannedDeliveryDateUtc', 'planned_delivery_date_utc');
        renameProperty(json, 'createdOnUtc', 'created_on_utc');
        renameProperty(json, 'packageTrackingNumber', 'package_tracking_number');

        for (const item of json.items) {
            renameProperty(item, 'quoteId', 'quote_id');
            renameProperty(item, 'packageTrackingNumber', 'package_tracking_number');
            renameProperty(item, 'shippingNoticeId', 'shipping_notice_id');
            renameProperty(item, 'assignedIdentification', 'assigned_identification');
            renameProperty(item, 'unitsShipped', 'units_shipped');
            renameProperty(item, 'serialNumbers', 'serial_numbers');
            renameProperty(item, 'quoteLineId', 'quote_line_id');
            renameProperty(item, 'partNumber', 'part_number');
            renameProperty(item, 'unshippedItems', 'unshipped_items');
        }

        return json;
    }
};

export type ShippingInfo = InstanceType<typeof ShippingInfo>
export const ShippingInfo = attributes({
  account: String,
  carrier: String,
  instructions: String,
  method: String,
  notice_count : String,
  po_number : Number
});